import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const FooterCopyright = ({
  footerLogo,
  spaceBottomClass,
  footerName,
  footerContact,
}) => (
  <div className={`copyright ${spaceBottomClass || ""}`}>
    <div className="footer-logo">
      <Link to={`${process.env.PUBLIC_URL}/`}>
        {footerLogo && (
          <img style={{ width: "200px" }} alt="" src={footerLogo} />
        )}
      </Link>
    </div>
    <p>
      <a href="/" rel="noopener noreferrer" target="_blank">
        {`© ${footerName}`}
      </a>
      <br />
      <span dangerouslySetInnerHTML={{ __html: footerContact }} />
    </p>
  </div>
);

FooterCopyright.propTypes = {
  footerLogo: PropTypes.string,
  spaceBottomClass: PropTypes.string,
};

export default FooterCopyright;
